<template>
  <div class="artwork-list-box">
    <!-- 艺术品列表页 -->
    <div class="the-body-box">
      <div class="banner-category-box">
        <!-- <img src="../../../../assets/img/banner.jpg" alt="" class="bg-img" /> -->
        <img src="https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/artwork_banner.jpg" alt="" class="bg-img" />
        <div class="category-list-box clearfix">
          <div class="catetory-left-box category-box f-l">
            <div
              class="first-class-item"
              v-for="(item, i) in categoryList"
              :key="i"
              @mouseenter="loadCategory(i, item.kindId)"
              @mouseleave="loadCategory(null)"
              @click="changeBanner(item)"
            >
              <div class="banner-change">
                <span class="name ellipsis">{{ item.chKindName }}</span>
                <span class="el-icon-arrow-right text-light-gray icons"></span>
              </div>
            </div>
          </div>
          <div
            class="category-right-box category-box f-l"
            :class="isShow ? 'active' : ''"
            @mouseover="isShow = true"
            @mouseleave="isShow = false"
          >
            <div class="clearfix">
              <div
                class="second-class-item"
                v-for="(item, i) in categoryListChild"
                :key="i"
              >
                <div @click="changeBanner(item)">
                  <!-- <img :src="item.kindPath" alt="" class="category-img" /> -->
                  <div class="name text-center ellipsis">
                    {{ item.chKindName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="artwork-list-content" id="artworkBox">
        <el-row :gutter="24">
          <el-col :span="6" :offset="18" class="artwork-search-input">
            <div class="el-input el-input--medium el-input--suffix">
              <input
                v-model="query.chArtworkName"
                type="text"
                autocomplete="off"
                :placeholder="$t('ArtworkDetail.EnterName')"
                class="el-input__inner"
                @keyup.enter="artworkList(1)"
              />
              <span
                class="el-input__suffix cursor-pointer"
                @click="artworkList(1)"
              >
                <span class="el-input__suffix-inner">
                  <i class="el-input__icon el-icon-search"></i>
                </span>
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="artwork-filters-box">
              <div class="lbl-box">
                <el-checkbox
                  v-model="query.excellent"
                  true-label="1"
                  false-label="0"
                  @change="artworkList(1)"
                  >{{ $t("ArtworkDetail.Excellent") }}</el-checkbox
                >
              </div>
            </div>
            <el-collapse class="artwork-filters-collapse" v-model="activeNames">
              <el-collapse-item
                :title="$t('ArtworkDetail.Size')"
                name="sizes"
                class="text-center"
              >
                <div class="colors-box sizes-box clearfix">
                  <div
                    class="f-l color-item cursor-pointer"
                    :class="i < currSize ? 'active' : ''"
                    v-for="(item, i) in 5"
                    :key="i"
                    @click="changeSize(1, i)"
                  ></div>
                </div>
                <div class="sizes-text-box clearfix">
                  <div class="text-item f-l text-left">0</div>
                  <div class="text-item f-l text-left">50cm</div>
                  <div
                    class="text-item f-l"
                    :class="currSize > 1 ? '' : 'text-light-gray'"
                  >
                    100cm
                  </div>
                  <div
                    class="text-item f-l text-right"
                    :class="currSize > 2 ? '' : 'text-light-gray'"
                  >
                    150cm
                  </div>
                  <div
                    class="text-item f-l text-right"
                    :class="currSize > 3 ? '' : 'text-light-gray'"
                  >
                    200cm
                  </div>
                  <div
                    class="text-item f-l text-right"
                    :class="currSize > 4 ? '' : 'text-light-gray'"
                  >
                    MAX
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                :title="$t('ArtworkDetail.ThemeColor')"
                name="colors"
                class="text-center"
              >
                <div class="colors-box clearfix">
                  <div
                    class="f-l color-item cursor-pointer"
                    :class="currColor == i ? 'active' : ''"
                    :style="`background-color: ${item};width:45PX`"
                    v-for="(item, i) in colorList"
                    :key="i"
                    @click="currColorSelect(i)"
                  ></div>
                  <div
                    class="f-l color-item cursor-pointer"
                    :class="currColor == 5 ? 'active' : ''"
                    :style="`background:url(${colorImg});width:45PX`"
                    @click="currColorSelect(5)"
                  ></div>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="$t('ArtworkDetail.Shape')" name="shape">
                <div class="shape-box text-center">
                  <span
                    class="iconfont cursor-pointer"
                    :class="
                      currShape == i ? `${item.solid} active` : item.hollow
                    "
                    v-for="(item, i) in shapeList"
                    :key="i"
                    @click="currShapeSelect(i)"
                  ></span>
                </div>
              </el-collapse-item>
              <!-- <el-collapse-item title="摆放空间" name="space">
								<div class="space-box">
									<div class="cursor-pointer" :class="currSpace==i?'':'text-light-gray'" v-for="(item,i) in spaceList" :key="i"
									 @click="currSpace=i">{{ item }}</div>
								</div>
							</el-collapse-item> -->
              <el-collapse-item
                :title="$t('LastTranslate.ScreenTitle2')"
                name="prive"
              >
                <div class="price-box">
                  <div>
                    {{ $t("PriceUnit") }}{{ filterParam.priceRange[0] }} - {{ $t("PriceUnit") }}{{
                      filterParam.priceRange[1]
                    }}
                  </div>
                  <el-slider
                    class="artwork-price-slider"
                    v-model="filterParam.priceRange"
                    range
                    :show-tooltip="false"
                    :min="50"
                    :max="100000"
                    @change="search"
                  ></el-slider>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
          <el-col
            :span="18"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            style="min-height: 650PX"
            class="common-loading-class"
          >
            <el-row
              :gutter="24"
              class="artwork-waterfall-list"
              :style="`height: ${listHeight}PX;`"
            >
              <el-col
                :span="8"
                v-for="(item, i) in artworkListArr"
                :key="i"
                class="artwork-card"
                :style="`height: ${item.height}PX;top: ${item.top}PX;left: ${item.left}PX;`"
              >
                <div class="artwork-item" :ref="`refs${i}`">
                  <router-link
                    :to="`/artwork-detail?artworkId=${item.artworkId}`"
                  >
                    <div class="artwork-img-box">
                      <h5 v-if="item.status != 5">
                        {{
                          item.status === 6
                            ? $t("ArtworkDetail.sold")
                            : item.status === 7
                            ? $t("ArtworkDetail.withdrawn")
                            : ""
                        }}
                      </h5>
                      <img :src="item.logoPath" alt="" class="art-img" />
                    </div>
                    <div class="text-box">
                      <div
                        class="txt text-gray ellipsis"
                        v-html="item.chArtworkName"
                      ></div>
                      <div class="txt text-gray ellipsis">
                        {{ item.chArtistName }}
                      </div>
                      <div class="clearfix">
                        <strong class="f-l price"
                          >{{ $t("PriceUnit") }} {{ item.price | fnKeep }}</strong
                        >
                        <span class="f-r common-tags" v-if="item.excellent">{{
                          $t("ArtworkDetail.Excellent")
                        }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <pc-pagination
              :pagOption="options"
              @current="artworkList"
            ></pc-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import pcPagination from "@/components/pagination";
import { log } from "util";
export default {
  components: {
    pcPagination,
  },
  data() {
    return {
      loading: false,
      isShow: false,
      categoryList: [],
      categoryListChild: [],
      currFirst: -1,
      activeNames: ["sizes", "colors", "shape", "space", "prive"], //默认全部展开
      filterParam: {
        priceRange: [0, 0],
        keyword: "",
        isOutstanding: false, //是否是杰出艺术品
        size: 1,
      },
      spaceList: [
        this.$t("LastTranslate.SittingRoom"),
        this.$t("LastTranslate.Bedroom"),
        this.$t("LastTranslate.Outdoor"),
        this.$t("LastTranslate.PublicHall"),
      ],
      currSpace: 1,
      shapeList: [
        //形状列表
        {
          hollow: "iconzhengfangxing1",
          solid: "iconzhengfangxing",
        }, //正方形
        {
          hollow: "iconhoutai-changfangxing",
          solid: "iconiconrectangle",
        }, //竖向长方形
        {
          hollow: "iconchangfangxing5",
          solid: "iconchangfangxing6",
        }, //横向长方形
        {
          hollow: "iconyuanxing2",
          solid: "iconyuanxing1",
        }, //圆形
        {
          hollow: "iconxing",
          solid: "iconxingxing",
        }, //星星
      ],
      currShape: null,
      colorList: ["#E73233", "#0099FF", "#32CC66", "#FFEA03", "#E6E6E6"],
      colorImg: require("../../../../assets/img/Group-12@3x.png"),
      currColor: null,
      currSize: 5,
      artworkListArr: [],
      listHeight: 0,
      query: {
        cursor: 1,
        limit: 9,
        chArtworkName: null,
        kindId: null,
        excellent: null,
        lowPrice: null,
        highPrice: null,
        beginHeight: null,
        endHeight: null,
        hue: null,
        shape: null,
        createTimeSort: null,
      },
      options: {
        total: null,
        size: null,
        current: null,
        pages: null,
      },
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  methods: {
    loadCategory(index, kindId) {
      if (index != null) {
        this.artworkKindList1(kindId);
        this.currFirst = index;
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    search() {
      this.query.lowPrice = this.filterParam.priceRange[0];
      this.query.highPrice = this.filterParam.priceRange[1];
      this.artworkList(1);
    },
    changeSize(type, index) {
      if (index != null) {
        this.currSize = index + 1;
      } else {
        this.currSize = this.filterParam.size;
      }
      switch (index) {
        case 0:
          this.query.endHeight = 50;
          break;
        case 1:
          this.query.endHeight = 100;
          break;
        case 2:
          this.query.endHeight = 150;
          break;
        case 3:
          this.query.endHeight = 200;
          break;
        case 4:
          this.query.endHeight = null;
          break;
      }
      this.artworkList(1);
    },
    currColorSelect(i) {
      this.currColor = i;
      this.query.hue = this.currColor + 1;
      this.artworkList(1);
    },
    currShapeSelect(i) {
      this.currShape = i;
      this.query.shape = this.currShape + 1;
      this.artworkList(1);
    },
    // 艺术品分类列表
    artworkKindList(id) {
      this.$commonPromise("get", this.$Api.artworkKindList).then((res) => {
        if (res.code === 200) {
          this.categoryList = res.data;
          if (id) {
            this.categoryListChild = res.data;
          }
        }
      });
    },
    // 查询二级分类
    artworkKindList1(id) {
      this.$commonPromise("get", this.$Api.artworkKindList, {
        kindId: id,
      }).then((res) => {
        if (res.code === 200) {
          this.categoryListChild = res.data;
        }
      });
    },
    changeBanner(item) {
      this.query.kindId = item.kindId;
      this.artworkList(1);
      window.location.href = '#artworkBox'
    },

    // 艺术品列表
    artworkList(page) {
      if (page) this.query.cursor = page;
      let parmas = {
        cursor: this.query.cursor,
        limit: this.query.limit,
        chArtworkName: this.query.chArtworkName
          ? this.query.chArtworkName
          : null,
        kindId: this.query.kindId,
        excellent: this.query.excellent,
        lowPrice: this.query.lowPrice,
        highPrice: this.query.highPrice,
        beginHeight: this.query.beginHeight,
        endHeight: this.query.endHeight,
        hue: this.query.hue,
        shape: this.query.shape,
        createTimeSort: this.query.createTimeSort,
      };
      this.loading = true;
      this.$commonPromise("get", this.$Api.artworkList, parmas).then((res) => {
        if (res.code === 200) {
          this.options.current = res.data.current;
          this.options.pages = res.data.pages;
          this.options.size = res.data.size;
          this.options.total = res.data.total;
          let arr = res.data.records;
          //需要在渲染前动态添加style字段，检测变化时才会重新渲染
          arr.forEach((item, i) => {
            item.height = 0;
            item.left = 0;
            item.top = 0;
          });

          //必须添加style字段后才能渲染数组，才能检测添加的style变化
          if (arr.length <= 0) {
            this.loading = false;
          }
          this.artworkListArr = arr;
        } else {
          this.loading = false;
        }
      });
    },
  },
  watch: {
    artworkListArr() {
      this.$nextTick(() => {
        let listHeight = 0;
        let colsHeight = [0, 0, 0]; //记录下来三列的当前高度，用来判断下一个放置在哪一列的下面
        const itemWith = (((1200 / 24) * 18) / 3).toFixed(0); //计算每列的宽度
        this.artworkListArr.forEach((item, i) => {
          setTimeout(() => {
            let k = i;
            const itemH = this.$refs[`refs${k}`][0].clientHeight + 24;
            this.artworkListArr[k].height = itemH;
            if (k < 3) {
              this.artworkListArr[k].top = 0;
              this.artworkListArr[k].left = k * itemWith + k * 6;
              colsHeight[k] = itemH;
            } else {
              let min = colsHeight[0];
              let minIndex = 0;
              colsHeight.forEach((col, index) => {
                console.log(col < min, "cole", min);
                if (col < min) {
                  minIndex = index;
                }
              });
              this.artworkListArr[k].top = colsHeight[minIndex];
              this.artworkListArr[k].left = minIndex * itemWith + minIndex * 6;
              colsHeight[minIndex] += itemH;
            }

            //最后一个的时候根据哪一列高度最大来计算盒子高度
            if (k == this.artworkListArr.length - 1) {
              let arr = colsHeight;
              let max1 = arr.sort(function (a, b) {
                return b - a;
              })[0];
              // console.log(max1,"hahaha");
              // let max = colsHeight[0];
              // let maxIndex = 0;
              // colsHeight.forEach((col, index) => {
              // 	if (col > max) {
              // 		maxIndex = index;
              // 	}
              // })
              this.listHeight = max1 + 64; //最后加上64是与分页的距离
            }
            this.loading = false;
          }, 600);
        });
      });
    },
  },
  mounted() {
    this.artworkKindList();
    this.artworkList();
  },
};
</script>
<style lang="scss" scoped>
.artwork-list-box {
  .banner-category-box {
    position: relative;
    height: 410PX;
    width: 100%;
    // background-image: url('../../../../assets/img/banner.png');
    // background-size: 100% 100%;
    .bg-img {
      width: 100%;
      height: 100%;
    }
    .category-list-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      .category-box {
        // height: 580PX;
        height: 410PX;
        overflow-y: auto;
        background-color: rgba(#000, 0.4);
        -ms-overflow-style: none; /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .catetory-left-box {
        width: 180PX;
        .first-class-item {
          position: relative;
          .banner-change {
            display: block;
            padding: 29PX;
          }
          &:not(:last-child) {
            border-bottom: 1PX solid rgba(#fff, 0.6);
          }
          .name {
            color: #fff;
            font-size: 16PX;
            cursor: pointer;
          }
          .icons {
            position: absolute;
            right: 16PX;
            top: 30PX;
          }
          &:hover {
            .name,
            .icons {
              color: $main-color;
            }
          }
        }
      }
      .category-right-box {
        display: none;
        // width: 1020PX;
        padding: 20PX 60PX;
        &.active {
          display: block;
        }
        .second-class-item {
          // width: 180PX;
          // margin-right: 20PX;
          .category-img {
            width: 180PX;
            height: 116PX;
          }
          .name {
            padding: 11PX 4PX 20PX;
            font-size: 16PX;
            color: #fff;
            cursor: pointer;
            &:hover {
              color: #FBC02D;
            }
          }
        }
      }
    }
  }
  .artwork-list-content {
    margin-top: 30PX;
    padding: 20PX 0 0;
    border-top: 1PX solid #ddd;
    // .artwork-search-input {
    //   padding-left: 24PX!important;
    //   padding-right: 0!important;
    // }
    .artwork-filters-box {
      margin-top: 24PX;
      .lbl-box {
        padding: 20PX 0;
        border-top: 1PX solid #ddd;
      }
    }
    .artwork-filters-collapse {
      .price-box {
        padding: 0 14PX;
      }
      .space-box {
        line-height: 2;
      }
      .shape-box {
        .iconfont {
          display: inline-block;
          zoom: 1;
          width: 45PX;
          color: $text-light-gray;
          font-size: 20PX;
          &.active {
            color: $main-color;
          }
        }
      }
      .colors-box {
        display: inline-block;
        zoom: 1;
        margin: 0 auto;
        .color-item {
          width: 50PX;
          height: 10PX;
          margin-right: 1PX;
          border: 1PX solid transparent;
          &.active {
            border-color: #000;
          }
        }
        &.sizes-box {
          .color-item {
            background-color: #e6e6e6;
            &.active {
              background-color: $main-color;
              border-color: transparent;
            }
          }
        }
      }
      .sizes-text-box {
        // display: inline-block;
        // zoom: 1;
        padding-left: 10PX;
        margin: 0 auto;
        .text-item {
          font-size: 10PX;
          width: 45PX;
          line-height: 10PX;
        }
      }
    }
    .artwork-waterfall-list {
      position: relative;
      .artwork-card {
        position: absolute;
        .artwork-item {
          margin-top: 24PX;
          &:hover {
            box-shadow: 0 0 15PX 3PX rgba(#000, 0.2);
          }
          .art-img {
            width: 100%;
          }
          .text-box {
            padding: 13PX 8PX 10PX 13PX;
            .price {
              line-height: 19PX;
            }
            .txt {
              margin-bottom: 8PX;
              height: 17PX;
            }
          }
        }
      }
    }
  }
}

.artwork-img-box {
  position: relative;

  h5 {
    width: 100PX;
    height: 100PX;
    border-radius: 50%;
    text-align: center;
    line-height: 100PX;
    color: #fff;
    font-size: 14PX;
    transform: rotate(45deg);
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.12), 0 0 6PX rgba(0, 0, 0, 0.04);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
